var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Block_contacts",
    "data-name": "Block contacts",
    transform: "translate(-432 -1216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    transform: "translate(432 1216)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 8.75,
    height: 1.5,
    rx: 0.75,
    transform: "translate(436.625 1224.156)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/block-icon.97921ef5e7f30e75e90adaca365f535d.svg";
export { ForwardRef as ReactComponent };